import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const SNIPPETS = buildModuleApi({
    prefix: "SNIPPETS",
    uri: "code-repositories",
    withExtra: false,
    exclude: ["LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL", "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    extraActions: {
        REPOSITORY_LIST: { suffix: "/repositories" },
        REPOSITORY_CREATE: { suffix: "/repositories" },
        REPOSITORY_UPDATE: { suffix: "/repositories" },
        REPOSITORY_REMOVE: { suffix: "/repositories" },
        REPOSITORY_ARCHIVE_LIST: { suffix: "/repositories/archived/list" },
        REPOSITORY_ARCHIVE: { suffix: "/repositories/:id/archive" },
        REPOSITORY_RESTORE: { suffix: "/repositories/:id/restore" },
        TREE: { suffix: "/repositories/:id/tree" },
        FOLDER_CREATE: { suffix: "/folders" },
        FOLDER_UPDATE: { suffix: "/folders" },
        FOLDER_REMOVE: { suffix: "/folders" },
        FOLDER_ARCHIVE_LIST: { suffix: "/folders/archived/list" },
        FOLDER_ARCHIVE: { suffix: "/folders/:id/archive" },
        FOLDER_RESTORE: { suffix: "/folders/:id/restore" },
        FILE_CREATE: { suffix: "/files" },
        FILE_UPLOAD: { suffix: "/files/upload" },
        FILE_CONTENT: { suffix: "/files/:id/content" },
        FILE_UPDATE: { suffix: "/files" },
        FILE_REMOVE: { suffix: "/files" },
        FILE_ARCHIVE_LIST: { suffix: "/files/archived/list" },
        FILE_ARCHIVE: { suffix: "/files/:id/archive" },
        FILE_RESTORE: { suffix: "/files/:id/restore" },
        FILE_DOWNLOAD: { suffix: "/files/:id/download" },
        VERSION_LIST: { suffix: "/files/:id/versions" },
        VERSION_DETAIL: { suffix: "/files/:fileId/versions/:versionId" },
        VERSION_RESTORE: { suffix: "/versions/restore" },
    },
});

export const SNIPPETS_API = SNIPPETS.API;
export const SNIPPETS_CONSTANTS = SNIPPETS.CONSTANTS;
export const SNIPPETS_ENDPOINTS = SNIPPETS.ENDPOINTS;
